import { I18nProvider } from '@lingui/react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { initSentry } from './helpers/sentry'
import { getDefaultLocale, i18n, loadLocale } from './i18n'

async function main() {
  // Before anything else so a failure while booting is reported too
  initSentry()
  // Load the user's preferred locale before rendering
  await loadLocale(getDefaultLocale())

  const container = document.getElementById('root')
  const root = createRoot(container as HTMLElement)
  root.render(
    <React.StrictMode>
      <I18nProvider i18n={i18n}>
        <App />
      </I18nProvider>
    </React.StrictMode>,
  )
}

main()
